module.exports = ""


//////////////////
// WEBPACK FOOTER
// D:/Repositorios/FacturacionWeb/src/app/main/footer/footer.component.html
// module id = ../../../../../src/app/main/footer/footer.component.html
// module chunks = main